function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.25,
  fill: "#F7F7F7",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 23.9678V17.2117C15 17.2117 17.3851 17.2232 19.363 16.2482C21.3409 15.2732 22.75 14 22.75 14C22.75 14 24.5748 15.3134 26.8328 16.2482C29.0909 17.183 30.5 17.2117 30.5 17.2117V24.8105C30.5 27.9021 25.1606 30.6489 23.3456 31.6709C22.9837 31.8764 22.5163 31.8764 22.1544 31.6709C20.3394 30.6489 15 28.4642 15 23.9678Z",
  stroke: "#AAAAAA",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 22.7656,
  y1: 18.6255,
  x2: 22.7656,
  y2: 27.2005,
  stroke: "#AAAAAA",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

const SvgAuthorizerFormIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "authorizer-form-icon",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAuthorizerFormIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/authorizer-form-icon.dbaf7978.svg";
export { ForwardRef as ReactComponent };